import firebase from 'firebase/app'
import axios from 'axios'
import Vue from 'vue'
const auth = firebase.auth();

axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalRequest = error.config;
      if (error.response.status == 401) {
        let newToken = await auth.currentUser.getIdTokenResult(true);
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + newToken.token;
        originalRequest.headers["Authorization"] = "Bearer " + newToken.token;
        return axios(originalRequest);
      }
      return Promise.reject(error);
    }
  );
  if (process.env.NODE_ENV === "dev") {
    axios.defaults.baseURL = "http://192.168.1.60:8111/";
  }
  if (process.env.NODE_ENV === "qa") {
    axios.defaults.baseURL = "https://quenco-testing.umatec.pe/";
  }
  if (process.env.NODE_ENV === "production") {    
    axios.defaults.baseURL = "https://api.asociaciontida.com/";
  }
Vue.prototype.$http = axios
